import { render, staticRenderFns } from "./MyArticleReceive.vue?vue&type=template&id=6c6282b3&scoped=true&"
import script from "./MyArticleReceive.vue?vue&type=script&lang=js&"
export * from "./MyArticleReceive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6282b3",
  null
  
)

export default component.exports